import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useFinancials } from './editor';

import { MaterialSymbol } from '@/components/MaterialSymbol';

const STATUS_DISPLAY = {
  saved: { label: 'saveStatus.Saved', icon: 'check', color: 'var(--fg-3)' },
  dirty: { label: 'saveStatus.Saving', icon: 'sync', color: 'var(--fg-3)' },
  saving: { label: 'saveStatus.Saving', icon: 'sync', color: 'var(--fg-3)' },
  error: { label: 'saveStatus.Error', icon: 'error', color: 'var(--color-error-80)' },
  conflict: { label: 'saveStatus.Conflict', icon: 'warning', color: 'var(--color-error-80)' },
} as const;

/** Contract autosave state in the project header (BR-20 in the UI). */
export const ContractSaveStatusChip = () => {
  const { state } = useFinancials();
  const { t } = useTranslation('pmFinancials');
  const display = STATUS_DISPLAY[state.saveStatus];

  return (
    <Box
      component="span"
      data-automation-id="save-status"
      data-state={state.saveStatus}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.5,
        mr: 1,
        borderRadius: 'var(--border-radius-pill)',
        fontSize: 11,
        color: display.color,
        whiteSpace: 'nowrap',
      }}
    >
      <MaterialSymbol name={display.icon} size={13} />
      {t(display.label)}
    </Box>
  );
};
